var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":"","color":"transparent"}},[_c('v-card-title',[_vm._v(" No Shipping ")]),_c('v-card-subtitle',[_vm._v(" This product does not require the capture of a shipping address at checkout ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }